module.exports = __webpack_public_path__ + "assets/img/shiyong.f74f62b8.png";